const courierData = Array.from({ length: 50 }, (_, i) => ({
  id: i + 1,
  companyName: `Courier Company ${i + 1}`,
  contactPerson: `Person ${i + 1}`,
  email: `courier${i + 1}@example.com`,
  website: `www.courier${i + 1}.com`,
  mobile: `98100000${String(i + 1).padStart(2, "0")}`,

  district: "Kathmandu",
  municipality: "Kathmandu Metropolitan",
  localArea: "Thamel",

  destinationDistrict: "Biratnagar",
  destinationMunicipality: "Biratnagar Metro",
  destinationLocalArea: "Main Road",

  serviceArea: "All Nepal",
  courierService: ["Economic", "Standard", "Air"][i % 3],

  transportType: ["Bike", "Van", "Truck"][i % 3],

  availableSpace: "150kg",
  itemQuota: `${5 + i} items`,

  length: "80cm",
  breadth: "60cm",
  height: "40cm",

  pricePerKg: 30 + i,
  pricePerItem: 70 + i,
  priceWholeSpace: 3000 + i * 15,

  departTime: "09:00 AM",
  deliveryTime: `${1 + (i % 3)} Days`
}));

export default courierData;